<template>
	<el-drawer :visible.sync="dialogVisible" :title="isUpdate ? '编辑达人' : '添加达人'" size="620px" :before-close="handleClose">
		<div class="drawer">
			<div class="drawer-wrap">
				<div class="mb-16" v-if="!isUpdate">
					<el-alert class="alert" title="达人信息的更新可能会延迟，请耐心等待..." type="warning" show-icon :closable="false" />
				</div>
				<el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
					<template v-if="notSingleVersion && !platformId">
						<div class="label">平台信息</div>
						<el-form-item label="达人所属平台" key="platform_id">
							<el-radio-group v-model="form.platform_id" @change="resetFields">
								<el-radio :label="dataMap.PLATFORM_DY.value">抖音</el-radio>
								<el-radio :label="dataMap.PLATFORM_KS.value">快手</el-radio>
								<el-radio :label="dataMap.PLATFORM_SP.value">视频号</el-radio>
							</el-radio-group>
						</el-form-item>
					</template>
					<div class="label">达人信息</div>
					<el-form-item v-if="$isDy(form.platform_id)" label="抖音号" prop="anchor_account" key="anchor_account_dy" :rules="dyRule">
						<el-input v-model="form.anchor_account" :disabled="isUpdate" placeholder="请输入抖音号" maxlength="16" />
						<p class="fz-12 yx-color-info text">最多16个字，只允许包含字母、数字、下划线和点</p>
					</el-form-item>
					<el-form-item v-if="$isKs(form.platform_id)" label="快手号/ID" prop="anchor_account" key="anchor_account_ks" :rules="ksRule">
						<el-input v-model="form.anchor_account" :disabled="isUpdate" placeholder="请输入快手号/ID" maxlength="20" />
						<p class="fz-12 yx-color-info text">快手ID为纯数字，快手号仅支持8-20个字母、数字、下划线或减号，必须以字母开头</p>
					</el-form-item>
					<el-form-item v-if="$isSp(form.platform_id)" label="视频号名称" prop="anchor_name" key="anchor_name" :rules="spRule">
						<div class="flex-row">
							<el-input v-model="form.anchor_name" placeholder="请输入视频号名称" maxlength="20" :disabled="isUpdate">
								<i class="el-icon-search el-input__icon" slot="prefix"></i>
							</el-input>
							<el-button v-if="!isUpdate" @click="handleSearchSp" :disabled="!form.anchor_name" class="ml-12" type="primary">搜索</el-button>
						</div>
						<p v-if="remoteStatus == 1" class="font-h6-regular color-gy-7 text">请输入精准视频号名称，否则无法获取达人在全网带货数据</p>
						<p v-if="remoteStatus == 2" class="font-h6-regular color-gy-7 text">
							<i class="el-icon-loading"></i>
							正在查询该达人...
						</p>
						<p v-if="remoteStatus == 3" class="font-h6-regular yx-color-warning text">
							<i class="el-icon-warning"></i>
							暂未获取到达人信息，可先导入系统后手动更新
						</p>
						<div v-if="remoteStatus == 4" class="flex-row-align-center flex-just-between yx-background p-12 radius-4 mt-8">
							<div class="flex-row-align-center flex-1 mr-20">
								<yx-avatar :size="28" :src="remoteAnchor.head"></yx-avatar>
								<platform-icon :platformId="3" class="ml-8 mr-2" />
								<div class="font-h4-medium line-ellipsis-1 flex-1">
									{{ remoteAnchor.anchorName }}
								</div>
							</div>
							<div class="flex-row-align-center color-gy-7 cursor-pointer" @click="handleRemoveSearch">
								<i class="el-icon-delete fz-14"></i>
								<div class="fz-12 ml-2">删除</div>
							</div>
						</div>
					</el-form-item>
					<el-form-item v-if="$isSp(form.platform_id)" label="视频号ID" prop="anchor_uid" key="anchor_uid" :rules="spRule2">
						<el-input v-model="form.anchor_uid" placeholder="请输入视频号ID，避免影响业绩" />
					</el-form-item>
					<el-form-item label="达人昵称" prop="anchor_name" key="anchor_name" v-if="$isDy(form.platform_id) || $isKs(form.platform_id)">
						<el-input v-model="form.anchor_name" :disabled="isUpdate" placeholder="请输入达人昵称" />
					</el-form-item>
					<el-form-item label="达人标签" prop="tagIds" key="tagIds" v-if="tagAuth">
						<SelectTag
							ref="selectTag"
							:selectValue="selectValue"
							style="width: 100%"
							:collapseTags="true"
							type="1"
							:multiple="true"
							v-model="form.tag_ids"
						></SelectTag>
					</el-form-item>
					<el-form-item label="备注" key="remark">
						<el-input v-model="form.remark" placeholder="请输入" />
					</el-form-item>

					<el-form-item v-if="$isDy(form.platform_id) && !isUpdate" label="主页链接" key="main_url">
						<el-input v-model="form.main_url" placeholder="请输入达人主页链接" />
					</el-form-item>
					<template v-if="!isUpdate">
						<template v-if="showContactForm">
							<div class="label">联系人信息</div>
							<el-form-item label="联系人名称" key="contact_name">
								<el-input v-model="form.contact_name" placeholder="请输入联系人名称" />
							</el-form-item>
							<el-form-item label="微信号" key="wechat_account">
								<el-input v-model="form.wechat_account" placeholder="请输入微信号" />
							</el-form-item>
							<el-form-item label="手机号" key="contact_mobile" prop="contact_mobile" :rules="mobileRules">
								<el-input v-model="form.contact_mobile" placeholder="请输入手机号" />
							</el-form-item>
						</template>
						<div class="label">跟进信息</div>
						<el-form-item label="合作状态" prop="cooperate_status" key="cooperate_status">
							<el-select v-model="form.cooperate_status" clearable placeholder="请选择合作状态">
								<el-option v-for="(item, index) in cooperateStatusList" :key="index" :label="item.label" :value="item.value" />
							</el-select>
						</el-form-item>
						<el-form-item label="跟进人" key="userId">
							<!---根据 视角的权限来控制 -->
							<el-select v-model="userId" clearable placeholder="请选择跟进人" v-if="followUpShow">
								<el-option v-for="(item, index) in partnerArr" :key="index" :label="item.name" :value="item.userId" />
							</el-select>
							<el-input v-else :value="vuex_userInfo.partner_role_name" disabled />
						</el-form-item>
					</template>
				</el-form>
			</div>
			<div class="bottom-btn">
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</div>
	</el-drawer>
</template>

<script>
import throttle from 'lodash/throttle';
import { mapState, mapGetters } from 'vuex';
import { addAnchor, getPartnerAnchorInfo, editEemark, setAnchorTags, searchSpByName, editSphAnchor, sphIdSearchList } from '@/api/talentCRM';
import { checkDouYin, isValidnum15 } from '@/utils/validate';
import { commonList } from '@/api/cooperationProgress';
import { drRoleType } from '@/utils/dataMap';
import SelectTag from '@/components/business/tagDialog/selectTag';
import { isTel } from '@/utils/reg';
//手机号验证
export const isValidMobile = (rule, value, callback) => {
	if (!value) {
		callback();
	}
	if (!isTel.test(value)) {
		callback(new Error('请输入正确的手机号'));
	} else {
		callback();
	}
};
export default {
	name: 'addTalentDialog',
	components: {
		SelectTag,
	},
	props: {
		platformId: {
			type: [Number, String],
			default: '',
		},
		showContactForm: {
			type: Boolean,
			default: true,
		},
		sourcePage: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			dialogVisible: false,
			form: {
				anchor_account: '',
				anchor_name: '',
				main_url: '',
				remark: '',
				contact_name: '',
				wechat_account: '',
				contact_mobile: '',
				cooperate_status: '',
				platform_id: '',
				anchor_uid: '',
			},
			cooperateStatusList: [
				{ value: 1, label: '线索' },
				{ value: 2, label: '已建联' },
				{ value: 3, label: '已申样' },
				{ value: 4, label: '已成交' },
			],
			partnerArr: [],
			userId: '',
			anchor_id: '',
			dyRule: [
				{ required: true, message: '请输入抖音号', trigger: 'blur' },
				{ required: true, validator: checkDouYin, trigger: 'blur' },
			],
			ksRule: { required: true, message: '请输入快手号/ID', trigger: 'blur' },
			spRule: { required: true, message: '请输入视频号名称', trigger: 'blur' },
			spRule2: [{ required: true, validator: isValidnum15, trigger: 'blur' }],
			rules: {
				anchor_name: { required: true, message: '请输入达人昵称', trigger: 'blur' },
				cooperate_status: { required: true, message: '请选择合作状态', trigger: 'change' },
			},
			mobileRules: { required: false, validator: isValidMobile, trigger: 'blur' },
			selectValue: [],
			//1 正常  2 请求中 3请求失败 4请求成功
			remoteStatus: 1,
			//搜索到的视频号达人数据
			remoteAnchor: {},
		};
	},
	computed: {
		...mapState(['vuex_userInfo']),
		...mapGetters(['canShowPlatformList', 'notSingleVersion']),
		isUpdate() {
			return !!this.anchor_id;
		},
		followUpShow() {
			return this.$auth.hasPermi('system:groupSeas:create') && this.sourcePage === 'groupSeas';
		},
		tagAuth({ sourcePage }) {
			const auth = {
				groupSeas: 'team-sea:search-tags',
			};
			return this.$auth.hasPermi(auth[sourcePage] || 'my-talent:search-tags');
		},
	},
	watch: {
		platformId: {
			handler() {
				this.setPlatformId();
			},
			immediate: true,
		},
	},
	methods: {
		show(anchor_id = '') {
			this.anchor_id = anchor_id;
			this.isUpdate && this.getPartnerAnchorInfo();
			this.followUpShow && this.getCommonList();
			this.dialogVisible = true;
		},
		handleClose() {
			this.resetFields();
			this.form = {
				anchor_account: '',
				anchor_name: '',
				main_url: '',
				remark: '',
				contact_name: '',
				wechat_account: '',
				contact_mobile: '',
				cooperate_status: '',
				platform_id: '',
				anchor_uid: '',
			};
			this.setPlatformId();
			this.partnerArr = [];
			this.selectValue = [];
			this.userId = '';
			this.anchor_id = '';
			this.remoteStatus = 1;
			this.remoteAnchor = {};
			this.dialogVisible = false;
		},
		resetFields() {
			this.$refs.ruleForm?.resetFields();
		},
		setPlatformId() {
			this.form.platform_id = this.platformId ? +this.platformId : +this.canShowPlatformList[0]?.value;
		},
		async getPartnerAnchorInfo() {
			const { anchor_id } = this;
			const { code, data: { anchor_data: { anchor_account = '', anchor_uid = '', anchor_name = '', remark = '', tag_arr = [] } } = {} } =
				await getPartnerAnchorInfo({ anchor_id });
			if (code !== 0) return;
			this.form.anchor_account = anchor_account || anchor_uid;
			this.form.anchor_name = anchor_name;
			this.form.remark = remark;
			this.selectValue = tag_arr?.map(item => item.tag_name);
			if (this.$isSp(this.form.platform_id)) this.form.anchor_uid = anchor_uid;
		},
		async getCommonList() {
			const { code, data } = await commonList({ role_id: drRoleType.id, all_status: 1 });
			if (code !== 0) return;
			this.partnerArr = data;
		},
		submit: throttle(function () {
			this.$refs.ruleForm.validate(async valid => {
				if (!valid) return;
				const code = await (this.isUpdate ? this.editTalent() : this.addAnchor());
				if (code !== 0) return;
				this.$message.success(`${this.isUpdate ? '修改' : '添加'}成功`);
				this.$emit('refresh');
				this.handleClose();
			});
		}, 1000),
		async addAnchor() {
			const { form, userId = '' } = this;
			const {
				anchor_account,
				anchor_name,
				main_url,
				remark,
				cooperate_status,
				platform_id,
				contact_name,
				wechat_account,
				contact_mobile,
				tag_ids,
				anchor_uid,
			} = form;
			let params = {
				anchor_account,
				anchor_name,
				cooperate_status,
				platform_id,
				remark,
				contact_name,
				wechat_account,
				contact_mobile,
				is_sea: 0,
				tag_ids,
			};
			const temPF = {
				[dataMap.PLATFORM_DY.value]: { ...params, main_url },
				[dataMap.PLATFORM_KS.value]: { ...params },
				[dataMap.PLATFORM_SP.value]: { ...params, anchor_uid, anchor_account: params.anchor_name },
			};
			params = temPF[this.form.platform_id] || {};
			if (this.followUpShow) {
				params.user_id = userId;
			}
			if (this.sourcePage == 'groupSeas') {
				params.is_sea = 1;
			}
			const { code } = await addAnchor(params);
			return code;
		},
		async editTalent() {
			const { form, anchor_id } = this;
			let { remark, tag_ids, anchor_uid, anchor_name } = form;
			let params = { anchor_id, remark };
			await setAnchorTags({ anchor_id, tag_ids: tag_ids || '' }); //编辑标签
			const temPF = {
				[dataMap.PLATFORM_DY.value]: params,
				[dataMap.PLATFORM_KS.value]: { ...params },
				[dataMap.PLATFORM_SP.value]: { ...params, anchor_uid, anchor_name },
			};
			params = temPF[this.form.platform_id] || {};

			if (this.$isSp(this.form.platform_id)) {
				await editSphAnchor({
					anchorId: anchor_id,
					videoNo: anchor_uid,
				});
			}
			const { code } = await editEemark(params);
			return code;
		},
		async handleSearchSp() {
			this.remoteStatus = 2;
			try {
				const { code, data } = await searchSpByName({ anchorName: this.form.anchor_name });
				if (code !== 0) return;
				if (!data.haveData) {
					this.remoteStatus = 3;
					return;
				}
				this.remoteStatus = 4;
				this.remoteAnchor = data;
			} catch (e) {
				this.remoteStatus = 1;
			}

			const res = await sphIdSearchList({ anchorName: this.form.anchor_name });
			if (res.video_no) this.form.anchor_uid = res.video_no;
		},
		handleRemoveSearch() {
			this.form.anchor_name = '';
			this.remoteAnchor = {};
			this.remoteStatus = 1;
		},
	},
};
</script>

<style lang="less" scoped>
.drawer {
	background: #fff;
	height: 100%;
	overflow: hidden;
	padding-bottom: 61px;
	.drawer-wrap {
		height: 100%;
		position: relative;
		overflow-y: auto;
		box-sizing: border-box;
		padding: 24px 24px 0;
		.alert {
			box-sizing: border-box;
			background-color: #e9f1ff;
			color: #333;
			border: 1px solid #bdd5ff;
			padding: 14px 16px;
			::v-deep .el-alert__icon {
				color: @color-primary;
			}
		}
		.label {
			font-size: 16px;
			color: #1d1f23;
			line-height: 20px;
			height: 20px;
			border-left: 4px solid #0053db;
			padding-left: 8px;
			margin-bottom: 16px;
		}
		.text {
			line-height: 12px;
			margin-top: 8px;
		}
	}
	.bottom-btn {
		border-top: 1px solid #eee;
		text-align: right;
		padding: 14px 24px;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
	}
}
</style>
